import { gql, useSubscription } from '@apollo/client';
import { useContext, useEffect } from 'react';
import { CompanyContext } from '../context/CompanyContext';
import React from 'react';
import { useRequest } from '../requests/common/requestHook';
import { OrderRequest } from '../requests/order.request';
import { Order } from '../types/order';
import { ProductTransactionRequest } from '../requests/productTransaction.request';
import { ProductRequest } from '../requests/product.request';
import { ProductContext } from '../context/ProductContext';
import { ProductTransaction } from '../types/productTransaction';
import { useDispatch } from 'react-redux';
import { productSlice } from '../providers/ProductProvider';
import { productTransactionSlice } from '../providers/ProductTransactionProvider';
import { orderSlice } from '../providers/OrderProvider';

const subscription = gql`
  subscription Notification($companyId: String!) {
    notification(companyId: $companyId) {
      ids
      companyId
      topic
      entity
    }
  }
`;

interface NotificationResponse {
  ids: string[];
  companyId: string;
  topic: string;
  entity: string;
}

export default function EntityNotification({}) {
  const { currentCompany } = useContext(CompanyContext);
  const dispatch = useDispatch();

  const { products, setProducts } = useContext(ProductContext);

  if (!currentCompany) return null;

  const { data: orderNotification } = useSubscription<{ notification: NotificationResponse }>(subscription, {
    variables: { companyId: currentCompany.id },
  });

  const [getOrders] = useRequest(OrderRequest.ids);
  const [getProductTransactions] = useRequest(ProductTransactionRequest.ids);
  const [getProducts] = useRequest(ProductRequest.ids);

  const handleOrderNotification = async (notification?: NotificationResponse) => {
    if (!notification) return;

    if (notification.entity === 'ORDER') {
      switch (notification.topic) {
        case 'CREATE':
        case 'UPDATE':
          const result = await getOrders({ ids: notification.ids, page: 0 });
          if (!result) return;

          dispatch(orderSlice.actions.add(result.data));
          break;
        case 'DELETE':
          dispatch(orderSlice.actions.delete(notification.ids.map(id => id) as any as Order[]));
          break;
      }
    } else if (notification.entity === 'PRODUCT_TRANSACTION') {
      switch (notification.topic) {
        case 'CREATE':
        case 'UPDATE':
          const result = await getProductTransactions({ ids: notification.ids, page: 0 });
          if (!result) return;

          dispatch(productTransactionSlice.actions.add(result.data));
          break;
        case 'DELETE':
          dispatch(
            productTransactionSlice.actions.delete(notification.ids.map(id => id) as any as ProductTransaction[]),
          );
          break;
      }
    } else if (notification.entity === 'PRODUCT') {
      switch (notification.topic) {
        case 'CREATE':
        case 'UPDATE':
          const result = await getProducts({ ids: notification.ids, page: 0 });
          if (!result) return;

          dispatch(productSlice.actions.add(result.data));
          break;
        case 'DELETE':
          notification.ids.forEach(id => products.delete(id));
          setProducts(new Map(products));
          break;
      }
    }
  };

  useEffect(() => {
    handleOrderNotification(orderNotification?.notification);
  }, [orderNotification]);

  return <></>;
}
